// capture/qualityChecks.js

/**
 * Checks mean luma from a downsampled 64x48 frame.
 * Rejects if underexposed (<40) or overexposed (>220).
 */
export function exposureOk(video) {
  if (!video || !video.videoWidth) return true;
  try {
    const c = document.createElement("canvas");
    c.width = 64;
    c.height = 48;
    const ctx = c.getContext("2d", { willReadFrequently: true });
    ctx.drawImage(video, 0, 0, 64, 48);
    const d = ctx.getImageData(0, 0, 64, 48).data;
    let sum = 0;
    for (let i = 0; i < d.length; i += 4) {
      sum += d[i] * 0.299 + d[i + 1] * 0.587 + d[i + 2] * 0.114;
    }
    const mean = sum / (d.length / 4);
    return mean >= 40 && mean <= 220;
  } catch (e) {
    return true;
  }
}

/**
 * Distance Check:
 * Enforces faceBox.width / video.videoWidth >= 0.35
 * If < 0.35, the candidate is too far and must come closer.
 */
export function faceDistanceOk(faceBoxWidth, videoWidth) {
  if (!faceBoxWidth || !videoWidth) return true;
  return (faceBoxWidth / videoWidth) >= 0.35;
}

// Backward-compatible alias
export const faceSizeOk = faceDistanceOk;
